/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useTranslations } from 'next-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, InSessionNotification, CollaborationNotification, Text } from '@components/design-system';
import { INotification } from '@interface/notification';
import { actions } from '@state/global';
import { RootState } from '@state/store';
import * as Styles from './styles';

export const NotificationsMenu: FC = () => {
  const t = useTranslations('notifications');
  const { notifications } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();

  const handleMarkAsRead = () => {
    for (let i = 0; i < notifications.length; i += 1) {
      dispatch({
        type: actions.GLOBAL_USER_VIEWS_NOTIFICATION,
        payload: notifications[i].notificationid,
      });
    }
  };

  const renderCell = (props: INotification) => {
    switch (props.type) {
      case 'collaboration':
        return (
          <CollaborationNotification
            notificationid={props.notificationid}
            timestamp={props.timestamp}
            viewed={props.viewed}
            {...props.body}
          />
        );
      case 'operationhash':
        return (
          <InSessionNotification
            notificationid={props.notificationid}
            timestamp={props.timestamp}
            viewed={props.viewed}
            {...props.body}
          />
        );
      default:
        return null;
    }
  };

  let hasUnread = false;
  for (let i = 0; i < notifications.length; i += 1) {
    if (notifications[i].viewed === false) {
      hasUnread = true;
    }
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Styles.Trigger hasNotification={notifications && hasUnread}>
          <i>notifications</i>
        </Styles.Trigger>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content asChild sideOffset={8}>
        <Styles.Content>
          <Box
            css={{
              width: '90vw',
              flexDirection: 'column',

              '@bp1': {
                width: 400,
              },
            }}
          >
            <Box css={{ flexDirection: 'column', '&>*:last-child': { borderBottom: 'unset' } }}>
              <Box css={{ padding: 12, justifyContent: 'space-between' }}>
                <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
                  {t('title')}
                </Text>
                <Button variant="basic" onClick={handleMarkAsRead}>
                  {t('read')}
                </Button>
              </Box>
              <Styles.Scrollable>
                {notifications && notifications.length > 0 ? (
                  notifications.map((notification: INotification) => {
                    return <Styles.Item key={notification.notificationid}>{renderCell(notification)}</Styles.Item>;
                  })
                ) : (
                  <Box vertical horizontal>
                    <Text unset css={{ color: '$secondaryFill', fontSize: 14, padding: '$space$4' }}>
                      {t('no-notifications')}
                    </Text>
                  </Box>
                )}
              </Styles.Scrollable>
            </Box>
          </Box>

          {/* <Box css={{ borderTop: '1px solid $colors$primaryBorder', padding: '$space$4' }} vertical horizontal>
            <Button variant="basic">See all notifications</Button>
          </Box> */}
        </Styles.Content>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
